import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { StateMagmntService } from '../services/state-magmnt-service';

export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);
export const SHOW_SKELETON = new HttpContextToken<boolean>(() => false);

let activeRequests = 0;
let skeletonRequests = 0;

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderStateManagement = inject(StateMagmntService);
  const skipLoader = req.context.get(SKIP_LOADER);
  const showSkeleton = req.context.get(SHOW_SKELETON);

  if (skipLoader) {
    return next(req);
  }

  if (showSkeleton) {
    skeletonRequests++;
    if (skeletonRequests === 1) {
      loaderStateManagement.showHideSkeleton(true);
    }
  } else {
    activeRequests++;
    if (activeRequests === 1) {
      loaderStateManagement.showHideLoader(true);
    }
  }

  return next(req).pipe(
    finalize(() => {
      if (showSkeleton) {
        skeletonRequests--;
        if (skeletonRequests === 0) {
          loaderStateManagement.showHideSkeleton(false);
        }
      } else {
        activeRequests--;
        if (activeRequests === 0) {
          loaderStateManagement.showHideLoader(false);
        }
      }
    })
  );
};
